import type { ID } from '@octopus-do/octopus-project-core'
import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '@store/reducers/dashboard/actions'
import { selectProjectParents } from '@store/reducers/dashboard/selectors'
import type { ProjectParents } from '@store/reducers/dashboard/types'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import { parseNestError } from '../../utils'

// The card jumps to the top of the list the moment it is pinned: the store is
// updated first and the request follows, as with archive. No success toast —
// unlike archive the card stays on screen, and the move is its own
// confirmation. A failed request moves it back and reports the error.
function* setPin(id: ID, pinned: boolean) {
  const path: ProjectParents | null = yield select(selectProjectParents(id))

  if (!path) {
    return
  }

  const update = (value: boolean) =>
    Internal.update({
      id,
      workspaceId: path.workspace.id,
      data: { pinned: value },
    })

  yield put(update(pinned))

  try {
    yield call(pinned ? NestClient.projects.pin : NestClient.projects.unpin, {
      ids: [id],
    })
  } catch (e) {
    yield put(update(!pinned))
    yield put(ErrorNotification(parseNestError(e)))
  }
}

export function* pin({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.pin>) {
  yield* setPin(id, true)
}

export function* unpin({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.unpin>) {
  yield* setPin(id, false)
}
